import React from 'react';
import { motion } from 'framer-motion';

/**
 * AnimatedSection - A reusable component for scroll-triggered animations
 * Uses framer-motion's whileInView for reliable viewport detection
 */
export const AnimatedSection = ({ 
  children, 
  className = '',
  animation = 'fadeUp',
  delay = 0,
  duration = 0.6,
  once = true
}) => {
  // Animation variants
  const animations = {
    fadeUp: {
      hidden: { opacity: 0, y: 30 },
      visible: { opacity: 1, y: 0 }
    },
    fadeIn: {
      hidden: { opacity: 0 },
      visible: { opacity: 1 }
    },
    slideLeft: {
      hidden: { opacity: 0, x: 50 },
      visible: { opacity: 1, x: 0 }
    },
    slideRight: {
      hidden: { opacity: 0, x: -50 },
      visible: { opacity: 1, x: 0 }
    },
    scale: {
      hidden: { opacity: 0, scale: 0.9 },
      visible: { opacity: 1, scale: 1 }
    },
    none: {
      hidden: { opacity: 1 },
      visible: { opacity: 1 }
    }
  };

  const selectedAnimation = animations[animation] || animations.fadeUp;

  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount: 0.2 }}
      variants={selectedAnimation}
      transition={{ 
        duration, 
        delay,
        ease: [0.25, 0.1, 0.25, 1] // Smooth ease-out curve
      }}
    >
      {children}
    </motion.div>
  );
};

/**
 * AnimatedCard - Specialized animation for cards with stagger support
 */
export const AnimatedCard = ({ 
  children, 
  className = '',
  index = 0,
  baseDelay = 0
}) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 40, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ 
        duration: 0.5,
        delay: baseDelay + (index * 0.15),
        ease: [0.25, 0.1, 0.25, 1]
      }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedSection;
